import Alpine from "alpinejs";

document.addEventListener("alpine:init", () => {
    Alpine.data("colorSelect", function (data) {
        const keys = Object.keys(data);
        const colorsList = keys.map((key) => ({
            color: key,
            img: data[key].url,
            hasBorder:
                data[key].group === "#F0EBEF" ||
                data[key].group === "#CCCACC" ||
                data[key].group === "#D9CEAB",
        }));

        const initialValue = colorsList[0];

        return {
            items: colorsList,
            current: initialValue,
            setColor(idx) {
                this.current = this.items[idx];
            },
        };
    });
});
